import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Book = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        d='M12.5626 7.37195C12.5626 6.31108 12.1411 5.29367 11.391 4.54352C10.6408 3.79338 9.62343 3.37195 8.56256 3.37195H2.56256V18.3719H9.56256C10.3582 18.3719 11.1213 18.688 11.6839 19.2506C12.2465 19.8132 12.5626 20.5763 12.5626 21.3719M12.5626 7.37195V21.3719M12.5626 7.37195C12.5626 6.31108 12.984 5.29367 13.7341 4.54352C14.4843 3.79338 15.5017 3.37195 16.5626 3.37195H22.5626V18.3719H15.5626C14.7669 18.3719 14.0038 18.688 13.4412 19.2506C12.8786 19.8132 12.5626 20.5763 12.5626 21.3719M16.5626 8.37195H18.5626M16.5626 12.3719H18.5626'
        stroke={primaryColorToUse}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.56256 3.37195H8.56256C9.62343 3.37195 10.6408 3.79338 11.391 4.54352C12.1411 5.29367 12.5626 6.31108 12.5626 7.37195V21.3719C12.5626 20.5763 12.2465 19.8132 11.6839 19.2506C11.1213 18.688 10.3582 18.3719 9.56256 18.3719H2.56256V3.37195Z'
        fill={primaryColorToUse}
      />
      <path d='M16.5626 8.37195H18.5626H16.5626Z' fill={primaryColorToUse} />
      <path d='M16.5626 12.3719H18.5626H16.5626Z' fill={primaryColorToUse} />
    </svg>
  );
};
